export enum PopupType {
  Prompt = 'Prompt',
  Modal = 'Modal'
}
